export default __webpack_public_path__ + "static/media/bus.4f6cf8ed.svg";